/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    const button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('open-cc');
        this.container.classList.toggle('active');
        this.container.removeAttribute('inert');
      });
    }
  }
}

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle {
  constructor() {
    this.container = document.getElementById('Sidebar-Container');
    const button = document.getElementById('Sidebar-Toggle');

    // Add functionality to buttons
    if (button) {
      const span = button.querySelector('span');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.container.classList.toggle('facets--sidebar-open');

        span.textContent = this.container.classList.contains('facets--sidebar-open') ? theme.strings.hideFilters : theme.strings.showFilters;
      });
    }
  }
}

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelectorAll('.thb-filter-content--button').forEach((more_button) => {
      more_button.addEventListener('click', this.onMore);
    });
     const formEl = this.querySelector('form');
    formEl.addEventListener('input', this.debouncedOnSubmit.bind(this));
    formEl.addEventListener('change', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
  setTimeout(() => {
    if (document.querySelector('#ProductGridContainer .collection.loading')) {
      window.location.href = `${window.location.pathname}?${searchParams}`;
    }
  }, 2000);
}
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
        new SidebarToggle();
        if (typeof window.initPriceBracketFilters === 'function') {
          window.initPriceBracketFilters();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
    new SidebarToggle();
    if (typeof window.initPriceBracketFilters === 'function') {
      window.initPriceBracketFilters();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

static renderFilters(html, event) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');

  facetDetailsElements.forEach((element) => {
    const targetElement = document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`);

    // Sort active items first
      const activeItems = Array.from(element.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'));
    const inactiveItems = Array.from(element.querySelectorAll('input[type="checkbox"]:not(:checked), input[type="radio"]:not(:checked)'));
    
    const ul = element.querySelector('ul');
    if (ul) {
      ul.innerHTML = '';
      activeItems.forEach(item => ul.appendChild(item.closest('li')));
      inactiveItems.forEach(item => ul.appendChild(item.closest('li')));
    }

    targetElement.innerHTML = element.innerHTML;
    if (typeof targetElement.setListeners === 'function') {
      targetElement.details = targetElement.querySelector('details');
      targetElement.summary = targetElement.querySelector('summary');
      targetElement.content = targetElement.querySelector('.collapsible__content');
      targetElement.initialized = false;
      targetElement.setListeners();
    }
  });

  FacetFiltersForm.renderActiveFacets(parsedHTML);
  FacetFiltersForm.renderAdditionalElements(parsedHTML);
  new FacetsToggle();
  new SidebarToggle();
  if (typeof window.initPriceBracketFilters === 'function') {
    window.initPriceBracketFilters();
  }

    const form = document.querySelector('facet-filters-form');
  if (form) {
    form.querySelectorAll('.thb-filter-content--button').forEach((button) => {
      button.removeEventListener('click', form.onMore);
      button.addEventListener('click', form.onMore);
    });
  }

  const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
  if (jsFilter) {
    const countsToRender = Array.from(facetDetailsElements).find(element => element.dataset.index === jsFilter.dataset.index);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, jsFilter);
  }
}

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

onSubmitHandler(event) {
  event.preventDefault();
  
  const formData = new FormData(event.target.closest('form'));
  const searchParams = new URLSearchParams(formData);

  // Clear previous price filters
   searchParams.delete('filter.v.price.gte');
   searchParams.delete('filter.v.price.lte');

  const form = event.target.closest('form');
  const checkedPriceFilters = form.querySelectorAll('.price-filter input:checked');
  
  if (checkedPriceFilters.length > 0) {
    // Assuming single-select for simplicity; for multiple ranges, further logic needed.
    const priceFilter = checkedPriceFilters[0];
    const min = priceFilter.dataset.min;
    const max = priceFilter.dataset.max;

    searchParams.set('filter.v.price.gte', min);
    searchParams.set('filter.v.price.lte', max);
  }

  FacetFiltersForm.renderPage(searchParams.toString(), event);
}

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = this.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      this.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      this.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.titleToggle = this.querySelector('#title_toggle');
    this.isDesktop = window.innerWidth >= 768;
    this.productLayout = this.isDesktop ? 'grid' : 'list';
    this.productGrid.dataset.layout = this.productLayout;
    this.storageKey = this.isDesktop
      ? 'show-product-titles-desktop'
      : 'show-product-titles-mobile';
    this.showTitles = window.localStorage.getItem(this.storageKey);

    const sortBySelect = document.getElementById('SortByBar');
if (sortBySelect) {
  sortBySelect.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    history.pushState(null, '', url);
    FacetFiltersForm.renderPage(url.searchParams.toString(), e, true);
  });
}
    
      if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
    if (this.titleToggle) {
      this.titleToggle.addEventListener('change', this.onTitleToggle.bind(this));
      if (this.showTitles === null) {
         this.titleToggle.checked = true
      } else {
        this.titleToggle.checked = this.showTitles === 'true';
      }
      this.updateTitleVisibility();
    }
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
  updateTitleVisibility() {
    document.body.classList.toggle('show-product-title', this.titleToggle && this.titleToggle.checked);
    document.body.classList.toggle('hide-product-title', this.titleToggle && !this.titleToggle.checked);
  }
  onTitleToggle(e) {
    this.updateTitleVisibility();
    window.localStorage.setItem(this.storageKey, e.target.checked);
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
  new SidebarToggle();
  if (typeof window.initPriceBracketFilters === 'function') {
    window.initPriceBracketFilters();
  }
});